import { useQuery } from '@tanstack/react-query'
import { api } from '../../api/client'

/**
 * База знаний (PoC, вариант C). Контент берём из BookStack через наш бэкенд-прокси
 * (`/api/kb/*`) и рендерим нативно — БЕЗ iframe/новой вкладки. Кэш «ленивый»:
 * книга/страница тянутся при первом открытии.
 */
/** Конфиг KB (базовый адрес BookStack для кнопок авторинга). Кэш «навсегда» — не меняется. */
export function useKbConfig() {
  return useQuery({ queryKey: ['kb', 'config'], queryFn: api.kbConfig, staleTime: Infinity })
}

export function useKbBooks() {
  return useQuery({ queryKey: ['kb', 'books'], queryFn: api.kbBooks })
}

export function useKbBook(id: number | null) {
  return useQuery({
    queryKey: ['kb', 'book', id],
    queryFn: () => api.kbBook(id as number),
    enabled: id != null,
  })
}

export function useKbPage(id: number | null) {
  return useQuery({
    queryKey: ['kb', 'page', id],
    queryFn: () => api.kbPage(id as number),
    enabled: id != null,
  })
}

/** Поиск по БЗ. Активен от 2 символов; пустой запрос не дёргает API. */
export function useKbSearch(q: string) {
  const term = q.trim()
  return useQuery({
    queryKey: ['kb', 'search', term],
    queryFn: () => api.kbSearch(term),
    enabled: term.length >= 2,
  })
}
